
import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link ,useParams} from "react-router-dom";
import axios from "axios";

const Signin = () => {
  const { referralId } = useParams();
  const defaultReferralId = referralId || "RJ01N001";
  const [formData, setFormData] = useState({
    studentName: "",
    phoneNumber: "",
    email: "",
    aadharNumber: "",
    address: "",
    district: "",
    taluk: "",
    password: "",
    referralid: defaultReferralId,
    RetypePassword: "",
  });

  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [otp, setOtp] = useState("");
  const [requestId, setRequestId] = useState("");
  const [orderId, setOrderId] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const sendmail = async (userId, password, email) => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/adddetails/sendmail`, {
        userId,
        password,
        email,
      });
    } catch (error) {
      console.error(
        "Error sending email:",
        error.response?.data?.message || error.message
      );
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/locations/districts`)
      .then((res) => res.json())
      .then((data) => setDistricts(data))
      .catch((err) => console.error("Error fetching districts:", err));
  }, []);

  useEffect(() => {
    const selectedDistrict = districts.find(
      (d) => d.name === formData.district
    );

    if (selectedDistrict?.id) {
      fetch(
        `${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`
      )
        .then((res) => res.json())
        .then((data) => setTalukas(data))
        .catch((err) => console.error("Error fetching taluks:", err));
    } else {
      setTalukas([]);
    }
  }, [formData.district, districts]);

  const handleSubmit = async (e) => {
    
    e.preventDefault();

    if (formData.password !== formData.RetypePassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    const viewPass = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/adddetails/addstudentform`,
        {
          ...formData,
          viewPass,
        }
      );

      const { userId, password, email } = response.data;
      // sendmail(userId, password, email);

      setFormData({
        studentName: "",
        phoneNumber: "",
        email: "",
        aadharNumber: "",
        address: "",
        district: "",
        taluk: "",
        password: "",
        referralid: "RJ01N001",
        RetypePassword: "",
      });

      setErrorMessage("");
      alert("Form submitted successfully!");
      window.location.reload();
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Error submitting the form."
      );
      console.error("Error submitting the form:", error);
    }
  };

  // const handleChange = (e) => {
  //   const { id, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [id]: value,
  //   }));
  // };
const handleChange = (e) => {
  const { id, value } = e.target;

  // Remove spaces only for password fields
  const newValue =
    id === 'password' || id === 'RetypePassword'
      ? value.replace(/\s/g, '')
      : value;

  setFormData((prevData) => ({
    ...prevData,
    [id]: newValue,
  }));
};

  const validateAadhaar = (number) => /^\d{12}$/.test(number);

  const sendOtp = async (e) => {
    e.preventDefault();

    const aadhaarNum = formData.aadharNumber;

    if (!validateAadhaar(aadhaarNum)) {
      alert("Invalid Aadhaar number. Please enter a 12-digit number.");
      return;
    }

    setLoading(true);

    try {
      const generatedOrderId = `ORDER_${new Date().getTime()}`;
      setOrderId(generatedOrderId);

      const response = await axios.post(
        `${process.env.REACT_APP_API}/send/send-otp`,
        {
          aadhaarNumber: aadhaarNum,
          orderid: generatedOrderId,
        }
      );

      setRequestId(response.data.ref_id);
      setMessage("OTP sent to your registered mobile number.");
    } catch (error) {
      if (error.response?.status === 409) {
        alert("Aadhaar number already registered.");
      } else {
        setMessage(
          error.response?.data?.message ||
            "Failed to send OTP. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();

    if (!otp || !requestId) {
      alert("Please enter OTP first");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/verify/verify-otp`,
        {
          otp,
          ref_id: requestId,
          orderid: orderId,
          aadhaar_number: formData.aadharNumber,
        }
      );

      const userDetails = response.data.data || {};
      setFormData((prev) => ({
        ...prev,
        studentName: userDetails.name || "",
        address: userDetails.address || "",
        phoneNumber: userDetails.phone || "",
      }));

      setMessage("Aadhaar verification successful!");
      setIsOtpVerified(true);
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
          "Failed to verify OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      {/* <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage:
              'url("assets/images/backgrounds/page-header-bg-1-1.jpg")',
          }}
        ></div>
        <div className="container">
          <h2 className="page-header__title">Student Register</h2>
          <ul className="cleenhearts-breadcrumb list-unstyled">
            <li>
              <i className="icon-home"></i> <Link to="/">Home</Link>
            </li>
            <li>
              <span>Register</span>
            </li>
          </ul>
        </div>
      </section> */}

      <section className="login-page section-space">
        <div className="container">
          <div className="row gutter-y-40">
            <div className="col-lg-6">
              {/* <div className="login-page__image">
                <img src="assets/images/login/login-1-1.jpg" alt="login" />
              </div> */}

<div className="login-page__image"
                  
                  style={{
                 position: 'relative',
                 width: '100%',
                 minHeight:'450px',
                 maxWidth: '600px',
                 maxHeight: '100%',
                 overflow: 'hidden',
                 paddingRight: '10px'
               }}
             >
               {/* Heading Overlay */}
               <h2
                   style={{
                   position: 'absolute',
                   top: '10px',
                   left: '20px',
                   margin: 0,
                   padding: '6px 12px',
                   backgroundColor: 'rgba(0, 0, 0, 0.6)',
                   color: '#fff',
                   fontSize: '24px',
                   fontWeight: 'bold',
                   borderRadius: '5px',
                   zIndex: 2
                 }}
               >
                 2023–2024 Winners
               </h2>
             
               {/* Desktop Images */}
               <img
                   src="assets/images/login/schlimg.jpg"
                   alt="login"
                   className="desktop-img"
                   style={{
                   position: 'absolute',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   animation: 'slideFade 9s infinite',
                   animationDelay: '0s',
                   opacity: '0',
                   animationFillMode: 'forwards'
                 }}
               />
               <img
                   src="assets/images/login/schlimg1.jpg"
                   alt="login1"
                   className="desktop-img"
                   style={{
                   position: 'absolute',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   animation: 'slideFade 9s infinite',
                   animationDelay: '3s',
                   opacity: '0',
                   animationFillMode: 'forwards'
                 }}
               />
               <img
                   src="assets/images/login/schlimg2.jpg"
                   alt="login2"
                   className="desktop-img"
                   style={{
                   position: 'absolute',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   animation: 'slideFade 9s infinite',
                   animationDelay: '6s',
                   opacity: '0',
                   animationFillMode: 'forwards'
                 }}
               />
             
               {/* Mobile Image */}
               <img
                   src="assets/images/login/schlimg.jpg"
                   alt="login-mobile"
                   className="mobile-img"
                   style={{
                   display: 'none',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   position: 'absolute'
                 }}
               />
             
               {/* Styles */}
               <style>
                 {`
                   @keyframes slideFade {
                     0% { opacity: 0; }
                     10% { opacity: 1; }
                     30% { opacity: 1; }
                     40% { opacity: 0; }
                     100% { opacity: 0; }
                   }
             
                   @media (max-width: 768px) {
                     .desktop-img {
                       display: none !important;
                     }
             
                     .mobile-img {
                       display: block !important;
                     }
                   }
                 `}
               </style>
             </div>
            </div>

            <div className="col-lg-6">
              <div className="login-page__form">
                <h2 className="login-page__form__title">
                  Welcome to our community
                </h2>

                {!isOtpVerified ? (
                  <form
                    onSubmit={sendOtp}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                      maxWidth: "400px",
                      margin: "0 auto",
                    }}
                  >
                    <h4>Aadhaar Verification</h4>
                    <input
                      type="text"
                      id="aadharNumber"
                      placeholder="Enter Aadhaar Number"
                      value={formData.aadharNumber}
                      onChange={handleChange}
                      maxLength={12}
                      className="form-one__control__input"
                    />

                    <button
                      type="submit"
                      disabled={loading}
                      className="cleenhearts-btn"
                      style={{ width: "50%" }}
                    >
                      {loading ? "Sending OTP..." : "Send OTP"}
                    </button>

                    {requestId && (
                      <>
                        <input
                          type="text"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          className="form-one__control__input"
                        />
                        <button
                          className="cleenhearts-btn"
                          onClick={verifyOtp}
                          disabled={loading}
                          style={{ width: "50%" }}
                        >
                          {loading ? "Verifying..." : "Verify OTP"}
                        </button>
                      </>
                    )}
                    {message && <p style={{ color: "green" }}>{message}</p>}
                  </form>
                ) : (
                  <form
                    className="login-page__form__box form-one"
                    onSubmit={handleSubmit}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      id="studentName"
                      placeholder="Student Name"
                      value={formData.studentName}
                      onChange={handleChange}
                      className="form-one__control__input"
                      readOnly
                    />
                    <input
                      type="text"
                      id="phoneNumber"
                      placeholder="Phone Number"
                      maxLength={10}
                      value={formData.phoneNumber}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        setFormData((prevData) => ({
                          ...prevData,
                          phoneNumber: newValue,
                        }));
                      }}
                      className="form-one__control__input"
                    />
                    <input
                      type="email"
                      id="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-one__control__input"
                    />


<textarea
                      id="address"
                      placeholder="Enter your address"
                      value={formData.address || ""}
                      onChange={handleChange}
                      style={{
                        padding: "8px",
                        width: "100%",
                        minHeight: "80px",
                      }}
                      readOnly
                    />

                    <select
                      id="district"
                      value={formData.district || ""}
                      onChange={handleChange}
                      className="form-one__control__input"
                    >
                      <option value="">Select District</option>
                      {districts.map((district) => (
                        <option key={district.id} value={district.name}>
                          {district.name}
                        </option>
                      ))}
                    </select>

                    <select
                      id="taluk"
                      value={formData.taluk || ""}
                      onChange={handleChange}
                      className="form-one__control__input"
                      disabled={!formData.district}
                    >
                      <option value="">Select Taluk</option>
                      {talukas.map((taluk) => (
                        <option key={taluk.id} value={taluk.name}>
                          {taluk.name}
                        </option>
                      ))}
                    </select>

               

                    <input
                      type="password"
                      id="password"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-one__control__input"
                    />
                    <input
                      type="password"
                      id="RetypePassword"
                      placeholder="Retype Password"
                      value={formData.RetypePassword}
                      onChange={handleChange}
                      className="form-one__control__input"
                    />

                    <button
                      type="submit"
                      style={{
                        padding: "15px",
                        backgroundColor: "#007BFF",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        borderRadius: "100px",
                      }}
                    >
                      Register
                    </button>

                    {errorMessage && (
                      <p style={{ color: "red" }}>{errorMessage}</p>
                    )}
                    {successMessage && (
                      <p style={{ color: "green" }}>{successMessage}</p>
                    )}
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Signin;
